import { render, staticRenderFns } from "./AdditionalSidepanel.vue?vue&type=template&id=54c4da1b&scoped=true&"
import script from "./AdditionalSidepanel.vue?vue&type=script&lang=js&"
export * from "./AdditionalSidepanel.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSidepanel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdditionalSidepanel.vue?vue&type=style&index=1&id=54c4da1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4da1b",
  null
  
)

export default component.exports